import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { View } from '@aws-amplify/ui-react';
import { API, Storage } from 'aws-amplify';
import gql from 'graphql-tag';
import './Training.css';
import YouTube from 'react-youtube';
import Vimeo from '@u-wave/react-vimeo';

export default function TrainingVideoPage() {
  const { lessonId, category } = useParams();
  const navigate = useNavigate();
  const [lessonData, setLessonData] = useState(null);
  const getLesson = async () => {
    const myQuery = gql`
      query GetLessonDetail($id: ID!) {
        getLessonDetail(id: $id) {
          id
          name
          description
          url
          urlType
          youTubeURL
          order
          imageName
          imageType
          posterImageName
          category
          createdAt
        }
      }
    `;
    let res;
    try {
      res = await API.graphql({
        query: myQuery,
        variables: { id: lessonId },
      });
    } catch (error) {
      alert("Couldn't Get Lessons!");
      console.error('We Got a Problem --- update later');
      return false;
    }
    const lesson = res.data.getLessonDetail;
    if (lesson.posterImageName === '') lesson.posterImageName = null;
    if (lesson.youTubeURL === '') lesson.youTubeURL = null;
    if (!lesson.youTubeURL) {
      lesson.videoURL = await Storage.get(lesson.imageName);
    } else {
      lesson.videoURL = 'null';
    }
    setLessonData(lesson);
  };

  const goBack = () => {
    navigate(`/training/${lessonData.category}`);
  };

  const convertDate = (date) => {
    const originalDate = new Date(date);
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }).format(originalDate);
  };

  useEffect(() => {
    if (!lessonId || !category) return;
    if (global.trainingVideos && global.trainingVideos[category]) {
      setLessonData(
        global.trainingVideos[category].find((vid) => vid.id === lessonId)
      );
    } else {
      getLesson();
    }
  }, []);

  return (
    <View id="single-video-page-view">
      <Box style={{ padding: '3vh 7vw' }}>
        <Typography
          onClick={goBack}
          className="hov"
          style={{ fontSize: '1.2rem', fontWeight: 'bold' }}
        >
          {'< Back to Media'}
        </Typography>
        <Box
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '15px',
          }}
        >
          <Box style={{ maxWidth: 960 }}>
            {lessonData &&
              lessonData.imageType === 'pdf' &&
              !lessonData.youTubeURL && (
                <iframe
                  src={lessonData.videoURL}
                  width="960"
                  height="585"
                  style={{ border: 'none' }}
                  title={lessonData.name}
                />
              )}
            {lessonData &&
              lessonData.imageType !== 'pdf' &&
              !(lessonData.youTubeURL || lessonData.url) && (
                <video
                  autoPlay={true}
                  width={960}
                  height={585}
                  controls
                  controlsList="nodownload"
                >
                  <source src={lessonData.videoURL} />
                </video>
              )}
            {lessonData &&
              (lessonData.youTubeURL ||
                (lessonData.url && lessonData.urlType === 'youtube')) && (
                <YouTubePlayer
                  videoId={
                    lessonData.youTubeURL
                      ? lessonData.youTubeURL
                      : lessonData.url
                  }
                />
              )}
            {lessonData && lessonData.url && lessonData.urlType === 'vimeo' && (
              <VimeoPlayer video={lessonData.url} />
            )}
            {lessonData &&
              lessonData.url &&
              lessonData.urlType === 'facebook' && (
                <FacebookPlayer url={lessonData.url} />
              )}
            {lessonData && (
              <Box style={{ marginTop: '25px', padding: '2px' }}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography
                    style={{
                      fontSize: '1.3rem',
                      fontWeight: 'bold',
                    }}
                  >
                    {lessonData.name}
                  </Typography>
                  <Typography style={{ margin: '0 15px' }}>|</Typography>
                  <Typography>{convertDate(lessonData.createdAt)}</Typography>
                </Box>
                <Typography
                  style={{
                    marginTop: '2rem',
                    overflowWrap: 'anywhere',
                  }}
                >
                  {lessonData.description}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </View>
  );
}

const YouTubePlayer = (props) => {
  const { videoId } = props;

  const opts = {
    height: '585',
    width: '960',
    playerVars: {
      autoplay: 1, // 1 enables autoplay, 0 disables it
    },
  };

  return <YouTube videoId={videoId} opts={opts} />;
};

const VimeoPlayer = (props) => {
  const { video } = props;

  return (
    <Vimeo key={video} video={video} autoplay={true} height={585} width={960} />
  );
};

const FacebookPlayer = (props) => {
  const { url } = props;
  const [embedError, setEmbedError] = React.useState(false);
  const embedSrc = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
    url
  )}&show_text=false&width=476`;

  if (embedError) {
    return (
      <Box
        style={{
          width: 476,
          height: 750,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          gap: '12px',
        }}
      >
        <Typography style={{ fontSize: '1.1rem', color: '#555' }}>
          {"This video couldn't be embedded."}
        </Typography>
        <Typography style={{ fontSize: '0.9rem', color: '#888' }}>
          {
            "Facebook Reels and some private videos don't support external embedding."
          }
        </Typography>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            marginTop: '8px',
            padding: '10px 24px',
            backgroundColor: '#1877F2',
            color: 'white',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: 'bold',
          }}
        >
          Watch on Facebook
        </a>
      </Box>
    );
  }

  return (
    <Box style={{ display: 'flex', justifyContent: 'center' }}>
      <iframe
        src={embedSrc}
        width="476"
        height="750"
        style={{ border: 'none', overflow: 'hidden' }}
        scrolling="no"
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        allowFullScreen
        title="Facebook Video"
        onError={() => setEmbedError(true)}
        onLoad={(e) => {
          try {
            const iframe = e.target;
            if (iframe.contentDocument?.body?.innerText === '') {
              setEmbedError(true);
            }
          } catch (_) {
            // Cross-origin — embed loaded, which means it's working
          }
        }}
      />
    </Box>
  );
};
